export default "__VITE_ASSET__28075e6e__"